const clearAllNotifications = async (): Promise<{ success: boolean; error?: string }> => {
  try {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') {
      return { success: false, error: 'Not in a browser environment' };
    }

    // Check if Notification API is supported
    if (!('Notification' in window)) {
      return { success: false, error: 'Notification API not supported' };
    }

    // Check if Service Worker is supported
    if (!('serviceWorker' in navigator)) {
      return { success: false, error: 'Service Worker not supported' };
    }

    // Get active service worker registration
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      return { success: false, error: 'No active service worker registration found' };
    }

    // Get all notifications
    const notifications = await registration.getNotifications();
    if (!notifications.length) {
      return { success: true }; // No notifications to clear
    }

    // Close all notifications in parallel
    await Promise.all(notifications.map(notification => notification.close()));
    
    return { success: true };
  } catch (error) {
    console.error('Error clearing notifications:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error occurred' 
    };
  }
};

export default clearAllNotifications;
